import React from 'react';
import { icons } from '@ublend-npm/aulaui-next';
import { AulaPlugin } from '../plugins';
import { oneDriveType } from './oneDriveType';
import { openOneDrivePicker } from './oneDrivePicker';
import { createCloudFileProviderPlugin } from '../cloudFileProvider/createCloudFileProvider';

export const oneDriveBusiness: AulaPlugin = createCloudFileProviderPlugin({
  name: 'OneDrive for Business',
  driveType: 'business',
  elementType: oneDriveType,
  icon: <icons.OneDrive />,
  onRequestFilePicker: openOneDrivePicker,
});
